import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CornerIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="#70707d" strokeLinecap="round" strokeLinejoin="round" d="M7.354 12 12 7.265m-8 3.603L10.719 4" /><path stroke="#171717" strokeLinecap="round" strokeLinejoin="round" d="M7.354 12 12 7.265m-8 3.603L10.719 4" /></svg>
  );
}

export default CornerIcon;
